export default {
    dashboard: "Dashboard",
    calendar: "Calendario",
    containers: "Container",
    activity: "Activity",
    quotes: "Preventivi",
    orders: "Ordini",
    receivers: "Receivers",
    shippers: "Spedizionieri",
    team: "Team",
    addressBook: "Address Book",
    settings: "Impostazioni",
    accounts: "Account",
    documents: "Documenti",
    workflows: "Workflow",
    support: "Supporto",
    logout: "Logout",
};
